import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { PagesProvider as Provider } from '@shapeable/ui';
import { sortBy } from 'lodash';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const PAGES_QUERY = graphql`
query NodeAllPagesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Pages" } }) {
    nodes {
      data
    }
  }
}
`;

export const PagesProvider: React.FC<any> = ({ children }) => {
  return (
    <Provider value={sortBy(shapeableProviderValue(useStaticQuery(PAGES_QUERY), 'items'), 'name')}>
      {children}
    </Provider>
  );
};
